import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "settings-container"
};
const _hoisted_2 = {
  class: "settings-preamble"
};
const _hoisted_3 = {
  class: "blank-answers-container"
};
const _hoisted_4 = {
  class: "blank-answer-row"
};
const _hoisted_5 = {
  class: "item-value-container"
};
const _hoisted_6 = {
  class: "item-image-container"
};
const _hoisted_7 = {
  key: 0,
  class: "blank-answer-error"
};
const _hoisted_8 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_question_answer_image_uploader = _resolveComponent("question-answer-image-uploader");
  const _component_w_input = _resolveComponent("w-input");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_w_dialog = _resolveComponent("w-dialog");
  return _openBlock(), _createBlock(_component_w_dialog, {
    visible: _ctx.isVisible,
    title: _ctx.$t('chapter.question.fillInTheBlanks.addBlank.modal.selectBlank.title'),
    width: "600px",
    class: "blank-as-dropdown-settings-dialog",
    "close-on-outside-click": false,
    onOnDialogClose: _ctx.closeDialog
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_8, [_createVNode(_component_standard_button, {
      outlined: true,
      label: _ctx.$t('chapter.question.fillInTheBlanks.addBlank.modal.selectBlank.cancelBtn'),
      onAction: _ctx.cancelSettingsEdit
    }, null, 8, ["label", "onAction"]), _createVNode(_component_standard_button, {
      label: _ctx.$t('chapter.question.fillInTheBlanks.addBlank.modal.selectBlank.validateBtn'),
      disabled: !_ctx.realtimeBlankData?.responses.length,
      onAction: _ctx.validateSettings
    }, null, 8, ["label", "disabled", "onAction"])])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('chapter.question.fillInTheBlanks.addBlank.modal.selectBlank.description')), 1), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.realtimeBlankData?.responses, answer => {
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_icon, {
        class: _normalizeClass(['blank-answer-radio', {
          'checked': answer.correctAnswer
        }]),
        icon: answer.correctAnswer ? 'radiobox-marked' : 'radiobox-blank',
        onClick: $event => _ctx.onBlankCorrectAnswerUpdate(answer)
      }, null, 8, ["class", "icon", "onClick"]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_question_answer_image_uploader, {
        image: answer.image,
        onImageUploaded: $event => _ctx.onAnswerImageChange($event, answer),
        onImageDelete: $event => _ctx.onImageDelete(answer)
      }, null, 8, ["image", "onImageUploaded", "onImageDelete"])]), _createVNode(_component_w_input, {
        class: _normalizeClass(['blank-answer-option-input', {
          'is-error': _ctx.shouldDisplayError(answer)
        }]),
        value: answer.image ? answer.image.imageLabel : answer.label,
        type: 'text',
        placeholder: _ctx.$t('chapter.question.fillInTheBlanks.addBlank.modal.selectBlank.optionInput.placeholder'),
        resize: "none",
        maxlength: _ctx.LABEL_NB_MAX_CHARS,
        onInput: $event => _ctx.onBlankAnswerOptionUpdate(answer, $event)
      }, null, 8, ["class", "value", "placeholder", "maxlength", "onInput"])]), _createVNode(_component_icon, {
        class: "delete-answer-icon",
        icon: "delete-outline",
        onClick: $event => _ctx.onBlankAnswerDelete(answer)
      }, null, 8, ["onClick"])]), _ctx.shouldDisplayError(answer) ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('chapter.question.fillInTheBlanks.addBlank.modal.selectBlank.optionInput.emptyValueErrorMsg')), 1)) : _createCommentVNode("", true)]);
    }), 256)), _createElementVNode("div", {
      class: "add-blank-item-btn",
      onClick: _cache[0] || (_cache[0] =
      //@ts-ignore
      (...args) => _ctx.addBlankAnswer && _ctx.addBlankAnswer(...args))
    }, [_cache[1] || (_cache[1] = _createTextVNode(" + ", -1)), _createElementVNode("u", null, _toDisplayString(_ctx.$t('chapter.question.fillInTheBlanks.addBlank.modal.selectBlank.addOptionBtn')), 1)])])])]),
    _: 1
  }, 8, ["visible", "title", "onOnDialogClose"]);
}